module.exports = __webpack_public_path__ + "img/plazaroja.15e12190.jpg";